import React, { useState, useCallback, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

function AdminLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for mobile sidebar

  // Memoize the toggle function to prevent unnecessary re-renders
  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen(prev => !prev);
  }, []);

  // Memoize the overlay click handler
  const handleOverlayClick = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  // Memoize styles for better performance
  const containerStyles = useMemo(() => 
    "flex min-h-screen w-full bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100 will-change-scroll", 
    []
  );

  const mainContentStyles = useMemo(() => 
    "flex-1 flex flex-col h-screen overflow-y-auto scroll-smooth transform-gpu", 
    []
  );

  const overlayStyles = useMemo(() => 
    "fixed inset-0 bg-gradient-to-br from-gray-900/70 to-indigo-900/70 backdrop-blur-sm z-40 md:hidden transition-all duration-300 will-change-transform", 
    []
  );

  return (
    // Main container for the entire dashboard UI (sidebar + header + content)
    <div className={containerStyles}> 
      {/* Sidebar - fixed on desktop, overlay on mobile */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content area - optimized for smooth scrolling */}
      <div className={mainContentStyles}>
        <Header toggleSidebar={toggleSidebar} />
        <main className="flex-1 p-3 md:p-4 bg-gradient-to-br from-gray-50 to-indigo-50 transform-gpu">
          <div className="max-w-full mx-auto will-change-scroll">
            <Outlet /> {/* Renders the nested route component */}
          </div>
        </main>
      </div>

      {/* Overlay for mobile sidebar - optimized for performance */}
      {isSidebarOpen && (
        <div 
          className={overlayStyles}
          onClick={handleOverlayClick}
        ></div>
      )}
    </div>
  );
}

export default AdminLayout;